import { render } from "./NotFound.vue?vue&type=template&id=a67615ae&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=a67615ae&lang=less&scoped=true"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67615ae"]])

export default __exports__